<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">พิมพ์บราโค๊ด</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
          <v-card elevation="4" style="border-radius: 15px">
            <v-card-title>
              <h4>รายการสินค้า</h4>
            </v-card-title>
            <v-card-title style="display: flex; justify-content: space-between">
              <div class="mr-5">
                <v-tabs color="#D6BFAF" v-model="product_type">
                  <v-tab>รายการสินค้า</v-tab>
                  <v-tab>รายการสินค้าใกล้หมดอายุ</v-tab>
                </v-tabs>
              </div>
              <div>
                <v-text-field
                  color="#D6BFAF"
                  class="input-radius inp-text-field"
                  append-icon="mdi-magnify"
                  hide-details="auto"
                  required
                  v-model="search"
                  placeholder="ค้นหา..."
                  single-line
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-card-title>
            <v-card-text>
              <v-data-table
                v-if="loading_table === false"
                show-select
                v-model="selected"
                :headers="headers"
                :items="data_list"
                :hide-default-footer="true"
                mobile-breakpoint="0"
                fixed-header
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td class="hidden_line">
                        <v-checkbox
                          color="#D6BFAF"
                          v-model="selected"
                          :value="item"
                        />
                      </td>
                      <td class="hidden_line">{{ item.barcode }}</td>
                      <td class="hidden_line">{{ item.product_name }}</td>
                      <td class="hidden_line">{{ item.unit_name }}</td>
                      <td class="hidden_line">
                        {{
                          item.price_standard == null
                            ? "-"
                            : formatPrice(item.price_standard)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
              <v-pagination
                class="justify-end"
                v-model="page"
                :length="page_all"
                :total-visible="7"
                color="#8cc63e"
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
          <v-card elevation="4" style="border-radius: 15px">
            <v-card-title>
              <h4>ตั้งค่าการพิมพ์</h4>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text"
                      >กระดาษ <span class="required--text">*</span></label
                    >
                    <v-autocomplete
                      color="#D6BFAF"
                      class="input-radius"
                      :items="paper_size"
                      item-text="size"
                      item-value="id"
                      prepend-inner-icon="mdi-file"
                      hide-details="auto"
                      v-model="paper_id"
                      :rules="[(v) => !!v || 'กรุณาเลือกข้อมูล']"
                      placeholder="กรุณาเลือกขนาดกระดาษ"
                      single-line
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                  <label class="label_form_text">การแสดงข้อมูล</label>
                  <v-form-group>
                    <v-checkbox
                      v-model="show_name"
                      label="แสดงชื่อสินค้า"
                      color="#D6BFAF"
                      hide-details
                    ></v-checkbox>
                  </v-form-group>
                </v-col>
                <v-col
                  xs="12"
                  sm="6"
                  md="6"
                  lg="3"
                  xl="3"
                  cols="6"
                  class="mt-6"
                >
                  <v-form-group>
                    <v-checkbox
                      v-model="show_price"
                      label="แสดงราคา"
                      color="#D6BFAF"
                      hide-details
                    ></v-checkbox>
                  </v-form-group>
                </v-col>
                <v-col
                  xs="12"
                  sm="6"
                  md="6"
                  lg="3"
                  xl="3"
                  cols="6"
                  class="mt-6"
                >
                  <v-form-group>
                    <v-checkbox
                      v-model="show_store"
                      label="แสดงชื่อร้านค้า"
                      color="#D6BFAF"
                      hide-details
                    ></v-checkbox>
                  </v-form-group>
                </v-col>
                <!-- <v-col xs="12" sm="6" md="6" lg="3" xl="3" cols="6" class="mt-6">
                  <v-form-group>
                    <v-checkbox v-model="ex4" label="แสดงโลโก้" color="#D6BFAF" hide-details></v-checkbox>
                  </v-form-group>
                </v-col> -->
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="6">
                  <label class="label_form_text"
                    >ขนาดบาร์โค้ด <span class="required--text">*</span></label
                  >
                  <v-autocomplete
                    color="#D6BFAF"
                    class="input-radius"
                    :items="barcode_size"
                    item-text="size"
                    item-value="id"
                    prepend-inner-icon="mdi-barcode-scan"
                    hide-details="auto"
                    v-model="barcode_size_id"
                    :rules="[(v) => !!v || 'กรุณาเลือกข้อมูล']"
                    placeholder="กรุณาเลือกขนาดบาร์โค้ด"
                    single-line
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="6"></v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="6">
                  <label class="label_form_text"
                    >จำนวนแนวตั้ง <span class="required--text">*</span></label
                  >
                  <v-autocomplete
                    color="#D6BFAF"
                    class="input-radius"
                    :items="[
                      {
                        size: 9,
                      },
                    ]"
                    item-text="size"
                    item-value="size"
                    v-model="vertical"
                    hide-details="auto"
                    placeholder="กรุณาเลือกจำนวนแนวตั้ง"
                    single-line
                    outlined
                    :rules="[(v) => !!v || 'กรุณาเลือกข้อมูล']"
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="6">
                  <label class="label_form_text"
                    >จำนวนแนวนอน <span class="required--text">*</span></label
                  >
                  <v-autocomplete
                    color="#D6BFAF"
                    class="input-radius"
                    :items="[
                      {
                        size: 3,
                      },
                    ]"
                    item-text="size"
                    item-value="size"
                    v-model="horizontal"
                    hide-details="auto"
                    placeholder="กรุณาเลือกจำนวนแนวนอน"
                    single-line
                    outlined
                    :rules="[(v) => !!v || 'กรุณาเลือกข้อมูล']"
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex justify-space-between">
                    <h3 style="font-size: 20px; color: #000000de">
                      ตัวอย่างก่อนพิมพ์
                    </h3>
                    <v-checkbox
                      class="ma-0"
                      v-model="show_border"
                      color="#D6BFAF"
                      label="แสดงเส้นประ"
                      hide-details="auto"
                    ></v-checkbox>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  id="barcode-page"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  cols="12"
                >
                  <v-card elevation="4" class="pa-3 card_relative grid_four_ck">
                    <div
                      class="text-center"
                      :style="
                        index + 1 > 32 * set_page[index] &&
                        index + 1 <= 36 * set_page[index]
                          ? `${
                              show_border
                                ? 'border: dashed 1px grey; border-radius: unset; margin-bottom:22px;'
                                : 'margin-bottom:22px;'
                            }`
                          : `${
                              show_border
                                ? 'border: dashed 1px grey; border-radius: unset;'
                                : ''
                            }`
                      "
                      v-for="(detail, index) in barcode_list"
                      :key="index"
                    >
                      <div style="font-size: 12px">
                        {{
                          show_name
                            ? detail.product_name.length > 20
                              ? detail.product_name.substring(0, 17) + "..."
                              : detail.product_name
                            : ""
                        }}

                        {{
                          show_price
                            ? detail.price_standard != null
                              ? "฿" + detail.price_standard
                              : "฿0"
                            : ""
                        }}
                      </div>
                      <!-- <div style="font-size: 12px" v-if="show_price">
                        {{
                          detail.price_standard != null
                            ? detail.price_standard
                            : "-"
                        }}
                      </div> -->
                      <div style="font-size: 12px" v-if="show_store">
                        {{ store_data != null ? store_data : "-" }}
                      </div>
                      <img ref="barcodeCanvas" :id="`img${index}`" alt="" />
                      <!-- <barcode
                        :value="detail.barcode"
                        :options="options"
                      ></barcode> -->
                      <!-- <div style="font-size:12px;">{{detail.barcode}}</div> -->
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content: center">
                    <v-btn
                      type="button"
                      class="btn_confirm_data"
                      elevation="4"
                      @click="print()"
                      large
                      >พิมพ์</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import {formatPrice} from "@/js/handler";
import JsBarcode from "jsbarcode";
// import VueBarcode from "vue-barcode";
export default {
  components: {
    // barcode: VueBarcode,
  },
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Detail_employee",
  data() {
    return {
      loading_page: true,
      loading_table: true,
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "พิมพ์บราโค๊ด",
          disabled: false,
          href: "#",
        },
      ],
      headers: [
        {
          text: "บาร์โค้ด",
          value: "",
          fixed: true,
          width: "150px",
        },
        {
          text: "ชื่อสินค้า",
          value: "",
          fixed: true,
          width: "150px",
        },
        {
          text: "หน่วยนับ",
          value: "",
          fixed: true,
          width: "150px",
        },
        {
          text: "ราคาขาย",
          value: "",
          fixed: true,
          width: "150px",
        },
      ],
      data_list: [],
      search: "",
      searchTimer: null,
      page: 1,
      page_all: 1,
      selected: [],
      barcode_list: [],
      paper_id: 1,
      paper_size: [
        { id: 1, size: "A4" },
        { id: 2, size: "กระดาษปริ้นบาร์โค๊ด" },
      ],
      barcode_size: [{ id: 1, size: "4.5 mm x 2 mm " }],
      barcode_size_id: 1,
      vertical: 9,
      horizontal: 3,
      show_name: 0,
      show_price: 0,
      show_store: 0,
      show_border: 0,
      set_page: [1],
      barcodeValue: "",
      product_type: 0,
      store_data: 0,
      options: {
        fontSize: 12,
        width: 1,
        height: 70,
      },
    };
  },
  methods: {
    formatPrice: function (value) {
      return formatPrice(value);
    },
    async getStore() {
      this.loading_page = true;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let store_id = this.$store.state.store_arin.user_data.store_id;
      await HTTP_ARIN.get("/stores/detail/" + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.store_data = res.data.storeDetail.store_name;
          console.log(res.data);
        }
      });
    },
    async selectAllHandler(items) {
      // Modify the selected array to only include the desired item
      alert(0);
      this.selected = await items.map((item) => item.id);
    },
    async generateBarcode(item) {
      await this.barcode_list.push(item);
      let index = (await this.barcode_list.length) - 1;
      let i = (await this.set_page.length) - 1;
      if (i + 1 > 36 * this.set_page[i]) {
        this.set_page.push(this.set_page[i] + 1);
      } else {
        this.set_page.push(this.set_page[i]);
      }
      await JsBarcode(`#img${index}`, item.barcode, this.options);
    },
    repeatNumbers(arr, times) {
      let result = [];
      for (let i = 1; i <= times; i++) {
        for (let j = 0; j < arr.length; j++) {
          result.push(arr[j]);
        }
      }
      return result;
    },
    async print() {
      // Your HTML content
      var divContents = document.getElementById("barcode-page").innerHTML;

      // Your CSS styles
      var cssStyles = `
  .card_relative {
    position: relative;
    border-radius: 15px;
  }
  
  .grid_four_ck {
    display: grid;
    text-align: center;
    grid-template-columns: 33.33% 33.33% 33.33% 33.33%;
  }
`;

      // Open a new window
      var a = window.open("", "", "height=500, width=500");
      a.document.write("<html>");
      a.document.write("<head>");
      a.document.write("<style>");
      // Add the CSS styles to the new window
      a.document.write(cssStyles);
      a.document.write("</style>");
      a.document.write("</head>");
      a.document.write("<body>");
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.close();
      a.print();
    },
    async productList() {
      this.data_list = [];
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let url = "";
      if (this.product_type == 0) {
        url = "/product/get/productlist";
      } else {
        url = "/pos/storage/product/expired/barcode/list/print";
      }
      await HTTP_ARIN.get(
        `${url}?page=${this.page}&search=${this.search}`,
        config
      ).then(async (res) => {
        if (res.data.successful === true) {
          this.data_list = await res.data.productList;
          this.loading_table = false;
          this.page = parseInt(
            res.data.current_page ? res.data.current_page : 1
          );
          this.page_all = res.data.count_page ? res.data.count_page : 1;
        }
      });
    },
  },
  mounted() {
    this.productList();
    this.getStore();
    this.loading_page = false;
  },
  watch: {
    async selected() {
      this.barcode_list.splice(0);
      await this.barcode_list.push(...this.selected);
      console.log(this.barcode_list);
      // const data = await this.selected;

      // this.selected = await data.map(detail => {
      //   return detail.id
      // })
      await this.selected.forEach(async (item, index) => {
        this.$nextTick(async () => {
          const canvas = await this.$refs["barcodeCanvas"][index];
          await JsBarcode(canvas, item.barcode, this.options);
        });
      });
    },
    page() {
      this.productList();
    },
    async search() {
      this.loading_table = true;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(async () => {
        this.page = 1;
        this.search  = this.search.replace(/,/g, '');
        await this.productList();
      }, 500);
    },
    product_type() {
      this.page = 1;
      this.search = "";
      this.barcode_list = [];
      this.selected = [];
      this.productList();
    },
  },
};
</script>

<style scoped>
.card_relative {
  position: relative;
  border-radius: 15px;
}

.profile_detail {
  display: grid;
  grid-template-columns: 30% 70%;
}

.header_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.title_card {
  color: #616a6b;
  font-weight: 600;
  font-size: 20px;
}

.sub_title_card {
  color: #616a6b;
  font-weight: 600;
  font-size: 18px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
}

.logo_timeline > img {
  max-width: 25px;
}

.tag_header_profile {
  position: absolute;
  top: -30px;
  left: -15px;
}

.arin-text-color {
  color: #84611f;
  font-weight: bold;
  font-size: 16px;
}

.arin-text-color-two {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.card_title {
  margin-top: 1px;
  margin-bottom: 1px;
  border-radius: 10px;
  border: 1px solid #d6bfaf;
}

.preview {
  border-radius: 10px;
}

.employee_box {
  border-radius: 10px;
  border: 1px solid #d6bfaf;
  width: auto;
}

.sub_title {
  font-size: 16px;
}

.image_title {
  font-weight: 500;
  font-size: 16px;
}

.picture_details {
  display: grid;
  grid-template-columns: 40% 60%;
}

.mobile_btn {
  width: 40%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_four_ck {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}

.text_title {
  color: #909090;
  font-weight: bold;
  font-size: 16px;
}

.text_detail {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.text_unit {
  font-size: 20px;
}

.btn_confirm_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 30%;
}
</style>
